import CandidatesList from 'components/embeds/stadtrat/candidatesList'
import React, { ReactElement } from 'react'
import './styles.scss'

export default function index(): ReactElement {
  const electionId = 'conseilEtat'
  return <CandidatesList electionId={electionId} />
}
